import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/product/ProductCard";

export default function SearchPage() {
  const [sp] = useSearchParams();
  const q = sp.get("q") || "";
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!q) return;
    setLoading(true);
    api.get("/products", { params: { q, limit: 60 } }).then((r) => setItems(r.data.items || [])).finally(() => setLoading(false));
  }, [q]);

  return (
    <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-10 md:py-16" data-testid="search-page">
      <div className="overline text-white/50 mb-3">Search Results</div>
      <h1 className="font-display text-4xl md:text-5xl tracking-tighter mb-8">"{q}"</h1>
      {loading ? <div className="text-white/60">Searching...</div> :
        items.length === 0 ? (
          <div className="border border-dashed border-white/15 py-16 text-center">
            <div className="font-display text-2xl mb-3">No matches</div>
            <p className="text-white/60 mb-6">Can't find what you're looking for?</p>
            <Link to="/ask-expert" className="sa-btn sa-btn-primary">ASK OUR AUTOMOTIVE TEAM</Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {items.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        )
      }
    </div>
  );
}
